import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Block from './components/Block'
import { fetchPageBySlug, clearCurrentPage } from './duck'
import './PageView.scss'

class PageView extends Component {
  componentDidMount() {
    const { match, currentLanguage } = this.props
    const slug = match.params.slug

    if (slug) {
      this.props.dispatch(fetchPageBySlug(slug, currentLanguage))
    }
  }

  componentWillReceiveProps(nextProps) {
    const currentSlug = this.props.match.params.slug
    const nextSlug = nextProps.match.params.slug

    // Fetch new page if slug changes
    if (currentSlug !== nextSlug && nextSlug) {
      this.props.dispatch(fetchPageBySlug(nextSlug, nextProps.currentLanguage))
    }

    // Re-fetch if language changes
    if (this.props.currentLanguage !== nextProps.currentLanguage && nextSlug) {
      this.props.dispatch(fetchPageBySlug(nextSlug, nextProps.currentLanguage))
    }
  }

  componentWillUnmount() {
    this.props.dispatch(clearCurrentPage())
  }

  render() {
    const { currentPage, loading, error } = this.props

    if (loading) {
      return (
        <div className="page-view loading">
          <p>Loading...</p>
        </div>
      )
    }

    if (error) {
      return (
        <div className="page-view error">
          <h1>Page not found</h1>
          <p>The page you are looking for does not exist.</p>
        </div>
      )
    }

    if (!currentPage) {
      return null
    }

    return (
      <div className="page-view">
        <div className="page-content">
          {currentPage.Blocks && currentPage.Blocks.length > 0 && (
            currentPage.Blocks
              .sort((a, b) => a.SortOrder - b.SortOrder)
              .map((block, index) => (
                <Block key={block.Id || index} block={block} />
              ))
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  currentPage: state.pages.currentPage,
  loading: state.pages.loading,
  error: state.pages.error,
  currentLanguage: state.app.currentLanguage || 'sv'
})

export default withRouter(connect(mapStateToProps)(PageView))
